import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IValidacionFormulario } from "./IValidacionFormulario-interface";


@Injectable({
  providedIn: "root",
})
export class ValidacionConyugeService implements IValidacionFormulario {
  validar(form: FormGroup): void {
    this.disableExcludedConyuge(form);
    form.get("EsValido")?.setValue(true);
  }

  private disableExcludedConyuge(form: FormGroup): void {
    if (!form) return;

    Object.keys(form.controls).forEach((controlName) => {
      form.get(controlName)?.disable({ emitEvent: false });
    });
  }
}
